import { useNavigate } from "react-router";
import { Navbar } from "src/components/Navbar/Navbar";
import { useGetPermaLink } from "src/utils/hooks/useGetPermaLink";
import { useTypedLocation } from "../../utils/hooks/useTypedLocation";
import { navigateToNewState } from "../../utils/location/navigateToNewState";
import { DebugSelectors } from "../DebugWindow/DebugSelectors";

export function DebugScreen() {
  const navigate = useNavigate();
  const location = useTypedLocation();
  const permalink = useGetPermaLink();

  const handleBack = () => {
    // go back to main user preferences screen
    navigateToNewState(navigate, { preferencesScreen: "main" }, location);
  };

  return (
    <div className="lg:pt-12">
      <Navbar headingText="Debug" onBackClick={handleBack} />
      <span className="flex items-center justify-between border-b-1 border-b-border text-body-md font-normal">
        <a href={permalink.href}>Current Feature Permalink</a>
      </span>
      <DebugSelectors />
    </div>
  );
}
